import { match } from "ts-pattern";
import { BannerFormSubmit, BannerLimitFreeUsage } from "./banners";
import { usePlaygroundContext } from "./context";

export function InputFormFooter({
  disabled,
  isAuthenticated,
  isLoading,
  onReset,
  submitLabel = "Run",
}: {
  disabled: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
  onReset: () => void;
  submitLabel?: string;
}) {
  const { version } = usePlaygroundContext();

  const conditions = {
    disabled,
  };

  return (
    <div className="input-form-footer sticky bottom-[-4px] bg-white dark:bg-r8-gray-1">
      {match(conditions)
        .with(
          {
            disabled: true,
          },
          () => (
            <BannerLimitFreeUsage
              isAuthenticated={isAuthenticated}
              version={version}
            />
          )
        )
        .with(
          {
            disabled: false,
          },
          () => (
            <BannerFormSubmit
              disabled={disabled}
              isLoading={isLoading}
              onReset={onReset}
              submitLabel={submitLabel}
            />
          )
        )
        .exhaustive()}
    </div>
  );
}
